import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonLink } from '../../../components/ButtonLink';
import { StatusPanel } from '../../../components/StatusPanel';
import { apiErrorMessageKey } from '../../../lib/api';
import { AuthPendingStatus } from '../components/AuthPendingStatus';

function BackToSignIn(): ReactElement {
    const { t } = useTranslation();
    return (
        <ButtonLink variant="contained" color="primary" to="/login">
            {t('AUTH.BACK_TO_SIGN_IN')}
        </ButtonLink>
    );
}

export function ConfirmEmailChangePending(): ReactElement {
    const { t } = useTranslation();
    return <AuthPendingStatus label={t('AUTH.CONFIRM_EMAIL_CHANGE.PENDING')} />;
}

export function ConfirmEmailChangeSuccess(): ReactElement {
    const { t } = useTranslation();
    return <StatusPanel severity="success" title={t('AUTH.CONFIRM_EMAIL_CHANGE.SUCCESS')} action={<BackToSignIn />} />;
}

export function ConfirmEmailChangeError({ error }: { error: unknown }): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="error"
            title={t(apiErrorMessageKey(error, 'ERRORS.CONFIRM_EMAIL_CHANGE_FAILED'))}
            action={<BackToSignIn />}
        />
    );
}
